// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomHeading_container__yWZRr","position-center":"CustomHeading_position-center__s0bVd","position-start":"CustomHeading_position-start___fqWh"};